/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.QuoteAvailableOtherLabourFilter = (function() {

    /**
     * Namespace QuoteAvailableOtherLabourFilter.
     * @exports QuoteAvailableOtherLabourFilter
     * @namespace
     */
    var QuoteAvailableOtherLabourFilter = {};

    QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter = (function() {

        /**
         * Properties of a QuoteAvailableOtherLabourFilter.
         * @memberof QuoteAvailableOtherLabourFilter
         * @interface IQuoteAvailableOtherLabourFilter
         * @property {string|null} [companyId] QuoteAvailableOtherLabourFilter companyId
         * @property {string|null} [query] QuoteAvailableOtherLabourFilter query
         * @property {string|null} [sortColumn] QuoteAvailableOtherLabourFilter sortColumn
         * @property {string|null} [sortOrder] QuoteAvailableOtherLabourFilter sortOrder
         * @property {number|null} [pageIndex] QuoteAvailableOtherLabourFilter pageIndex
         * @property {number|null} [pageSize] QuoteAvailableOtherLabourFilter pageSize
         */

        /**
         * Constructs a new QuoteAvailableOtherLabourFilter.
         * @memberof QuoteAvailableOtherLabourFilter
         * @classdesc Represents a QuoteAvailableOtherLabourFilter.
         * @implements IQuoteAvailableOtherLabourFilter
         * @constructor
         * @param {QuoteAvailableOtherLabourFilter.IQuoteAvailableOtherLabourFilter=} [p] Properties to set
         */
        function QuoteAvailableOtherLabourFilter(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * QuoteAvailableOtherLabourFilter companyId.
         * @member {string|null|undefined} companyId
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.companyId = null;

        /**
         * QuoteAvailableOtherLabourFilter query.
         * @member {string|null|undefined} query
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.query = null;

        /**
         * QuoteAvailableOtherLabourFilter sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.sortColumn = null;

        /**
         * QuoteAvailableOtherLabourFilter sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.sortOrder = null;

        /**
         * QuoteAvailableOtherLabourFilter pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.pageIndex = null;

        /**
         * QuoteAvailableOtherLabourFilter pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        QuoteAvailableOtherLabourFilter.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * QuoteAvailableOtherLabourFilter _companyId.
         * @member {"companyId"|undefined} _companyId
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_companyId", {
            get: $util.oneOfGetter($oneOfFields = ["companyId"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOtherLabourFilter _query.
         * @member {"query"|undefined} _query
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_query", {
            get: $util.oneOfGetter($oneOfFields = ["query"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOtherLabourFilter _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOtherLabourFilter _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOtherLabourFilter _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * QuoteAvailableOtherLabourFilter _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @instance
         */
        Object.defineProperty(QuoteAvailableOtherLabourFilter.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified QuoteAvailableOtherLabourFilter message. Does not implicitly {@link QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter.verify|verify} messages.
         * @function encode
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @static
         * @param {QuoteAvailableOtherLabourFilter.IQuoteAvailableOtherLabourFilter} m QuoteAvailableOtherLabourFilter message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableOtherLabourFilter.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.companyId != null && Object.hasOwnProperty.call(m, "companyId"))
                w.uint32(10).string(m.companyId);
            if (m.query != null && Object.hasOwnProperty.call(m, "query"))
                w.uint32(18).string(m.query);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(26).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(34).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(40).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(48).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified QuoteAvailableOtherLabourFilter message, length delimited. Does not implicitly {@link QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter.verify|verify} messages.
         * @function encodeDelimited
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @static
         * @param {QuoteAvailableOtherLabourFilter.IQuoteAvailableOtherLabourFilter} message QuoteAvailableOtherLabourFilter message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        QuoteAvailableOtherLabourFilter.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a QuoteAvailableOtherLabourFilter message from the specified reader or buffer.
         * @function decode
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter} QuoteAvailableOtherLabourFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableOtherLabourFilter.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.companyId = r.string();
                    break;
                case 2:
                    m.query = r.string();
                    break;
                case 3:
                    m.sortColumn = r.string();
                    break;
                case 4:
                    m.sortOrder = r.string();
                    break;
                case 5:
                    m.pageIndex = r.int32();
                    break;
                case 6:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a QuoteAvailableOtherLabourFilter message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {QuoteAvailableOtherLabourFilter.QuoteAvailableOtherLabourFilter} QuoteAvailableOtherLabourFilter
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        QuoteAvailableOtherLabourFilter.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return QuoteAvailableOtherLabourFilter;
    })();

    return QuoteAvailableOtherLabourFilter;
})();

module.exports = $root;
